
























































































import Vue from "vue";

//Component
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import NewSoftwareVersionsFilter from "@/components/TableHeaderFilters/NewSoftwareVersionsFilter.vue";
import TemplateInfoDialog from "@/views/App/SecurityAndConfiguration/CaosConfigurationTemplate/TemplateInfoDialog.vue";
import DeleteTemplateDialog from "@/views/App/SecurityAndConfiguration/CaosConfigurationTemplate/DeleteTemplateDialog.vue";
import ForceTemplateWizard from "./ForceTemplateWizard.vue";
import AddTemplateWizard from "./AddTemplateWizard.vue";

//Model
import { dataTableItemsPerPage, MODULE_COLORS } from "@/utility/Constants";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { DeleteConfigurationTemplateCommand } from "@/model/communication/caosConfiguration/DeleteConfigurationTemplateCommand";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    components: {
        TableFiltersRow,
        TemplateInfoDialog,
        DeleteTemplateDialog,
        ForceTemplateWizard,
        AddTemplateWizard,
    },
    data() {
        return {
            MODULE_COLORS,
            headers: [
                {
                    text: "",
                    value: "templateIcon",
                    sortable: false,
                },
                {
                    text: this.$t("caosTemplate.templateName"),
                    value: "name",
                },
                {
                    text: this.$t("caosTemplate.caosVersion"),
                    value: "caosVersion",
                    align: "center",
                },
                {
                    text: this.$t("caosTemplate.sourceInstallation"),
                    value: "sourceInstallationName",
                    align: "center",
                },
                {
                    text: this.$t("caosTemplate.templateDescription"),
                    value: "description",
                    sortable: false,
                    width: "35vw",
                },
                {
                    text: this.$t("common.actions"),
                    value: "actions",
                    align: "center",
                    sortable: false,
                    width: "150px",
                },
            ],
            filters: [
                {
                    headerValue: "caosVersion",
                    filterKey: UpdateTypeEnum.Caos,
                    component: NewSoftwareVersionsFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.Caos, versionType: "caosConfigurationTemplate" },
                },
            ],
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            dataTableItemsPerPage,
            options: {},
            showInfoDialog: false,
            showDeleteDialog: false,
            currentTemplate: null,
            currentTemplateName: "",
            deleteLoading: false,
            showForceTemplateWizard: false,
            showAddTemplateDialog: false,
        };
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        configurationTemplate: { required: true, type: Array },
        reqData: Object,
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
    },
    methods: {
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = false;
                this.options.page = 1;
                console.log("backToTheFirst, this.options: ", this.options);
            }
        },

        openInfoDialog(item) {
            this.currentTemplate = item;
            this.showInfoDialog = true;
        },
        openDeleteDialog(item) {
            this.currentTemplate = item;
            this.currentTemplateName = item.name;
            this.showDeleteDialog = true;
        },

        async deleteTemplate() {
            try {
                this.deleteLoading = true;
                let response: ApiGenericResponse = await new DeleteConfigurationTemplateCommand(this.currentTemplate.id).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.showDeleteDialog = false;
                    this.$emit("reload");
                    this.showAlert = true;
                }
            } catch (e) {
                console.log("Something went wrong sending GetConfigurationTemplate request ", e);
            }
            this.deleteLoading = false;
        },
        async openForceTemplateWizard(item) {
            this.currentTemplate = item;
            this.showForceTemplateWizard = true;
        },
    },
});
